export const webcall = params => {
  return new Promise((resolve, reject) => {
    try {
      // ios
      if (/iPhone|iPad/i.test(navigator.userAgent)) {
        window.webkit.messageHandlers.app.postMessage(JSON.stringify(params));
        resolve();
      }
      // android
      if (window.app && window.app.webcall) {
        window.app.webcall(JSON.stringify(params));
        resolve();
      }
    } catch (error) {
      // reject();
      console.log(`与app交互失败：${JSON.stringify(params)}`);
    }
  });
};